module.exports = __webpack_public_path__ + "static/media/icomanual_usuario.33038ec6.svg";